module.exports = __webpack_public_path__ + "media/images/placeholder-live-sessions-ccb52cba.png";